import React from "react";
import "../styles/canvaslines.css";
import { AnimatePresence, motion } from "framer-motion";
import { useAudio } from "./AudioContext";

export default function CanvasLines() {
  const { playAudio } = useAudio();

  const handleClick = () => {
    playAudio();
  };

  const handleLink = () => {
    playAudio();
    window.open("mailto:ramahesh024@gmail.com", "_blank");
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 30, opacity: 0 }}
        transition={{ duration: 0.4 }}
        className="canvaslines"
      >
        <div className="outer">
          <a href="#works">
            <div className="inner">
              <i
                onClick={handleClick}
                className="fi fi-rr-arrow-small-down"
              ></i>
            </div>
          </a>
          <p className="email" onClick={handleLink}>
            ramahesh024@gmail.com
          </p>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
